export enum RepOrderShipToEnum {
    SalesRep,
    Customer
}